module.exports = "/assets/6a9d712b4b1480df334054a94146cc34.png";